

















import Vue from "vue";

export default Vue.extend({
  name: "CheckBoxFilter",
  props: {
    tag: {
      type: Object,
      required: true,
    },
    CheckFunction: {
      type: Function,
      required: true,
    },
  },
});
